<template>
  <el-form ref="judgmentForm" :inline="false" :model="reappraisalBoardMemberJudgment" label-width="180px">
    <el-form-item v-if="isReappraisal && this.workingApplication.overdue">
      <el-alert :closable="false" type="warning" :title="OVERDUE_MESSAGE" show-icon
        style="border: 1px solid; background-color: #fdf6ec;"></el-alert>
    </el-form-item>
    <el-form-item label="Κατηγορία αίτησης" v-if="isReappraisal">
      <el-switch disabled v-model="workingApplication.legalIssue"
        active-text="Νομικό ζήτημα" inactive-text="Ακαδημαϊκό ζήτημα"></el-switch>
    </el-form-item>
    <proposals></proposals>
    <internalComments></internalComments>
    <br>
    <el-form-item label="Επιτροπή Επανεξέτασης">
      <el-table :data="membersDecisions" style="width: 100%">
        <el-table-column label="Αποφάσεις Μελών" align="center">
          <el-table-column label="Ονοματεπώνυμο">
            <template slot-scope="scope">
              <span>{{ scope.row.name }}</span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="Όνομα"  width="250">
            <template slot-scope="scope">
              <span>{{ scope.row.firstname }}</span>
            </template>
          </el-table-column> -->
          <el-table-column v-if="isReappraisal" label="Πλήρης αποδοχή" width="150" align="center">
            <template slot-scope="scope">
              <span class="agree-btn" v-if="scope.row.fullyAgreeWithReappraisal === 1"> <i class="el-icon-check"></i></span>
              <span class="disagree-btn" v-if="scope.row.fullyAgreeWithReappraisal === 0"> <i class="el-icon-close"></i></span>
              <!-- <span class="pending-btn" v-if="scope.row.fullyAgreeWithReappraisal === null"> <i class="el-icon-minus"></i></span> -->
              <span class="pending-btn" v-if="scope.row.fullyAgreeWithReappraisal === null"> <i class="el-icon-edit"></i></span>
            </template>
          </el-table-column>
          <!-- <el-table-column label="Υποβολή"  width="150" align="center">
            <template slot-scope="scope">
              <span class="done-btn" v-if="scope.row.finalize === true"> <i class="el-icon-check"></i></span>
              <span class="pending-btn" v-if="scope.row.finalize === false || scope.row.finalize === null"> <i class="el-icon-edit"></i></span>
            </template>
          </el-table-column> -->
          <el-table-column label="Συντονιστής"  width="150" align="center">
            <template slot-scope="scope">
              <span class="done-btn" v-if="scope.row.isLeader === true"> <i class="el-icon-check"></i></span>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </el-form-item>
    <el-form-item label="Εισήγηση επιτροπής">
      <el-alert v-if="reappraisalProposalFound" type="success"
        title="Είναι αναρτημένη στην καρτέλα Επισυναπτόμενα" show-icon :closable="false"></el-alert>
        <el-alert v-else type="error"
        title="Δεν υπάρχει αναρτημένη Εισήγηση" show-icon :closable="false"></el-alert>
    </el-form-item>
    <!-- <el-form-item label="Ανάρτηση εγγράφων"
      v-if="isCurrentUserLeader &&
      ((this.reappBoardAttachments.length > 0 && this.reappBoardAttachments.slice(-1)[0].uid === this.currentUser.id) ||
      this.workingApplication.attachedDocuments.slice(-1)[0].uploadedBy === this.currentUser.id)"
    > -->
    <el-form-item label="Ανάρτηση εγγράφων" v-if="isCurrentUserLeader">
      <el-radio-group v-model="uploadedDocType" @change="onDocTypeChange">
        <el-radio :label="1006" :disabled="reappraisalProposalFound">Εισήγηση</el-radio>
        <el-radio :label="1014">Συνοδευτικό έγγραφο</el-radio>
      </el-radio-group>
      <el-upload v-loading="this.uploading"
        class="upload-demo"
        ref="uploadReappraisalProposalRef"
        accept=".pdf"
        :file-list="reappBoardAttachments"
        :http-request="addAttachment"
        :on-remove="handleRemove"
        :on-preview="viewPdf"
        :before-remove="handleBeforeRemove"
        action=""
        :limit=10
        :auto-upload="true"
        :show-file-list='true'>
        <el-button slot="trigger" size="small" type="primary" @click.native="handleBeforeTrigger">Ανέβασμα</el-button>
        <div class="el-upload__tip" slot="tip">** Μ Ο Ν Ο για μία (1) εισήγηση της Ειδ. Επιτρ. Επανεξέτασης ή/και άλλα συνοδευτικά έγγραφα (αρχεία pdf μεγέθους μέχρι 12MB)</div>
      </el-upload>
    </el-form-item>
    <el-form-item v-if="isCurrentUserLeader">
      <el-checkbox label='Επιστροφή της αίτησης στον Πρόεδρο' v-model="returnToPresident" :disabled="reappraisalProposalFound">
      </el-checkbox>
    </el-form-item>
    <el-form-item v-if="returnToPresident" label="Σχόλιο επιστροφής">
      <el-input class="return-comment" type="textarea" placeholder="Σχόλιο επιστροφής της αίτησης στον Πρόεδρο (υποχρεωτικό)"
        v-model="returnComment" size="100" :autosize="{ minRows: 4, maxRows: 10 }">
      </el-input>
    </el-form-item>
    <div style="text-align: center">
      <el-button v-if="!isCurrentUserLeader" size="mini" type="primary" round="" @click="tempSave()" :disabled="!tempEnabled">
        Αποδοχή εισήγησης
      </el-button>
      <el-button v-else size="mini" type="danger" round="" @click="finalSave()" :disabled="!finalEnabled">
        Οριστική Υποβολή
      </el-button>
    </div>
  </el-form>
</template>

<script>
import axios from 'axios'
import { mapGetters, mapState } from 'vuex'
import internalComments from '../common/internalComments'
import Proposals from '../common/Proposals'
import sharedMethods from '../common/sharedMethods.js'

export default {
  components: {
    internalComments,
    Proposals
  },
  mixins: [sharedMethods],
  props: ['application', 'isReappraisal'],
  created: function () {
    this.getReappraisalBoard()
  },
  data () {
    return {
      // modified: false,
      // vicePresidentCall: '',
      // selectedUsers: [],
      // dialogView: false,
      // reappraisalBoardExists: null,
      // reappraisalBoardMembers: [],
      currentMember: null,
      otherMembers: null,
      isCurrentUserLeader: null,
      myJudgment: {
        fullyAgreeWithReappraisal: false,
        finalize: false
      },
      membersDecisions: [],
      uploadedDocType: 1006,
      // addingProposal: false,
      attachments: [],
      uploading: false,
      returnToPresident: false,
      returnComment: ''
    }
  },
  methods: {
    getReappraisalBoard () {
      const appId = this.workingApplication.id
      const getBoardUrl = `${this.BASE_URL}/reappraisal_boards?application_id=${appId}`
      // Get reappraisal board for this app id
      axios.get(getBoardUrl)
        .then(getBoardResponse => {
          const dataArray = getBoardResponse.data && getBoardResponse.data.data
          if (Array.isArray(dataArray) && dataArray.length > 0) {
            console.log('>>> app id', dataArray[0].application_id, 'board id', dataArray[0].id)
            const reappraisalBoardMembers = dataArray[0].members
            this.currentMember = reappraisalBoardMembers.find(i => i.memberId === this.currentUser.id)
            this.otherMembers = reappraisalBoardMembers.filter(i => i.memberId !== this.currentUser.id)
            this.isCurrentUserLeader = !!this.currentMember.is_coordinator
            this.myJudgment = {
              fullyAgreeWithReappraisal: this.currentMember.suggestion_accepted,
              finalize: false
            }
            this.membersDecisions = this.moveLeaderFirst(reappraisalBoardMembers).map(item => {
              return {
                id: item.memberId,
                surname: item.surname,
                name: `${item.surname} ${item.name}`,
                isLeader: !!item.is_coordinator,
                fullyAgreeWithReappraisal: item.suggestion_accepted,
                finalize: false
              }
            })
            if (dataArray.length > 1) {
              console.log('Σφάλμα με το πλήθος των επιτροπών επανεξέτασης')
            }
          }
        })
        .catch(err => {
          this.frontEndError('Σφάλμα κατά την ανάκτηση της Επιτροπής Επανεξέτασης')
          this.catchError(err)
        })
    },
    handleBeforeTrigger (event) {
      if (this.uploadedDocType === 1006 && this.reappraisalProposalFound) {
        this.frontEndError('Μονο μία Εισήγηση της Επιτροπής Επανεξέτασης είναι δεκτή')
        event.preventDefault()
        event.stopPropagation()
        return false
      }
    },
    onDocTypeChange () {
      // console.log('uploaded doc type', this.uploadedDocType)
    },
    moveLeaderFirst (board) {
      const leaderIndex = board.findIndex(member => member.is_coordinator === 1)
      if (leaderIndex <= 0) {
        return board
      }
      const result = [...board]
      const leader = result.splice(leaderIndex, 1)[0]
      result.unshift(leader)
      return result
    },
    toggleAgree (val) {
      if (this.myJudgment.fullyAgreeWithReappraisal === false) {
        this.$notify.warning({
          title: 'Προειδοποίηση',
          message: 'Προσοχή! Για να Ολοκληρώσετε την αίτηση απαιτείται Αποδοχή της εισήγηση της Ειδικής Επιτροπής Επανεξέτασης (την οποία θα βρείτε στην καρτέλα Επισυναπτόμενα)',
          offset: 300
        })
      }
    },
    addAttachment (file, fileList) {
      this.attachments.push(file.file)
      let self = this
      return this.getData(file.file).then(data => {
        self.fileData = data
        self.fileName = file.file.name
        self.newAttachment(this.uploadedDocType)
      })
    },
    newAttachment (docType) {
      let payload = {
        file: this.fileData, // Το τελικο αρχείο σε base64
        name: this.fileName, // Το όνομα του αρχείου
        type: docType,
        uuid: this.currentUser.id
      }
      this.uploading = true
      console.log('new attachment', payload.name, payload.type)
      axios.post(
        `${this.BASE_URL}/users/${this.currentUser.id}/applications/${this.workingApplication.id}/attachments`, payload
      ).then((response) => {
        let id = response.data.data.id
        this.uploading = false
        // this.reappraisalProposalFound = true
        this.frontEndSuccessMsg('Το αρχείο επισυνάφθηκε με επιτυχία')
        let reappBoardAttached = this.reappBoardAttachments.slice(0)
        reappBoardAttached[reappBoardAttached.length] = {type: payload.type, name: payload.name, uid: payload.uuid, id: id}
        this.$store.dispatch('SET_REAPPBOARD_ATTACHMENTS', reappBoardAttached)
      }).catch(err => {
        // this.frontEndError('Σφάλμα κατά την επισύναψη του αρχείου')
        this.catchError(err)
      }).finally(() => {
        this.getReappraisalBoard()
      })
    },
    handleBeforeRemove (file, fileList) {
      return this.$confirm(`Να αφαιρεθεί το ${file.name}？`)
    },
    handleRemove (file, fileList) {
      return axios.delete(
        `${this.BASE_URL}/users/${this.currentUser.id}/applications/${this.workingApplication.id}/attachments/${file.id}`
      ).then(response => {
        this.attachments = []
        this.fileData = ''
        this.fileName = ''
        this.$store.dispatch('SET_REAPPBOARD_ATTACHMENTS', this.reappBoardAttachments.filter(attachment => attachment.id !== file.id))
      }).catch(err => {
        this.backendError(err)
        throw err
      }).finally(() => {
        this.getReappraisalBoard()
      })
    },
    viewPdf (file) {
      const base64Data = encodeURI(this.fileData)
      this.openPdfWindow(file.name, base64Data)
    },
    getData (file) {
      return new Promise((resolve, reject) => {
        const fReader = new FileReader()
        let base64Pdf
        fReader.onload = (fileLoadedEvent) => {
          base64Pdf = fileLoadedEvent.target.result
          resolve(base64Pdf.split(',')[1])
        }
        fReader.readAsDataURL(file)
      })
    },
    tempSave () {
      // let payload = {
      //   fullyAgreeWithReappraisal: this.myJudgment.fullyAgreeWithReappraisal === null
      //     ? false
      //     : this.myJudgment.fullyAgreeWithReappraisal,
      //   finalize: false
      // }
      const payload = {
        suggestionAccepted: true
      }
      const msg = `Δηλώνετε ότι συμφωνείτε με την εισήγηση της Ειδικής Επιτροπής Επανεξέτασης.
        Θέλετε να συνεχίσετε;.`
      this.$confirm(msg,
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        axios.put(
          `${this.BASE_URL}/specialreappraisalboardmembers/uuid/applications/${this.workingApplication.id}/temp`,
          { judgment: payload }
        ).then((response) => {
          this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
          this.frontEndSuccessMsg('Τα δεδομένα αποθηκεύτηκαν με επιτυχία')
        }).catch(err => {
          this.frontEndError('Σφάλμα κατά την προσωρινή αποθήκευση')
          this.catchError(err)
        })
      })
    },
    getLastProponentId () {
      const history = [...this.workingApplication.applicationHistory]
      const lastProponentStep = history.slice().reverse().find(step => step.applicationStatus === 'proponentW_Prechecker')
      return lastProponentStep.user.id
    },
    finalSave () {
      let msg = ''
      let payload = null
      if (!this.returnToPresidentAllowed) {
        let userToId = ''
        if (this.workingApplication.legalIssue) {
          userToId = 'uid'
        } else {
          userToId = this.getLastProponentId()
        }
        msg = 'Ως συντονιστής, επιλέγετε την οριστική υποβολή της εισήγησης της Ειδικής Επιτροπής Επανεξέτασης. Συμφωνείτε;'
        payload = {
          assignedTo: {
            uid: userToId
          }
        }
      } else {
        msg = 'Η αίτηση θα επιστραφεί στον Πρόεδρο. Συμφωνείτε;'
        payload = {
          assignedTo: {
            role: 'President'
          },
          reappBoardCoordinatorComment: this.returnComment
        }
      }
      this.$confirm(msg,
        'Προειδοποίηση', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Άκυρο',
          type: 'warning'
        }).then(() => {
        axios.put(
          `${this.BASE_URL}/specialreappraisalboardmembers/uuid/applications/${this.workingApplication.id}/final`,
          {
            judgment: payload
          }
        ).then((response) => {
          this.$store.dispatch('LOAD_ASSIGNED_APPLICATIONS', this.activeLane)
          this.frontEndSuccessMsg('Τα δεδομένα αποθηκεύτηκαν με επιτυχία')
        }).catch(err => {
          this.frontEndError('Σφάλμα κατά την οριστική αποθήκευση')
          this.catchError(err)
        })
      })
    },
    catchError (err) {
      this.backendError(err)
      throw err
    }
  },
  computed: {
    // myJudgment () {
    //   return this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].judgment.find(item => item.uid === this.currentUser.id)
    // },
    // membersDecisions () {
    //   return this.workingApplication.applicationHistory[this.workingApplication.applicationHistory.length - 1].judgment.filter(item => item.uid !== this.currentUser.id)
    // },
    tempEnabled () {
      const result = !this.isCurrentUserLeader && this.currentMember && !(this.currentMember.suggestion_accepted === 1) &&
        this.reappraisalProposalFound
      return result
    },
    finalEnabled () {
      return (this.isCurrentUserLeader && this.reappraisalProposalFound && this.otherMembersAccepted) || this.returnToPresidentAllowed
    },
    otherMembersAccepted () {
      let result = this.otherMembers && this.otherMembers.length > 0
      this.otherMembers.forEach(member => {
        if (!(member.suggestion_accepted === 1)) {
          result = false
        }
      })
      return result
    },
    reappraisalProposalFound () {
      return !!this.application.attachedDocuments.slice(0).find(step => step.type === 1006)
    },
    reappraisalBoardMemberJudgment (val) {
      return Object.assign({}, this.workingApplication.applicationHistory.slice(0).reverse()
        .find(step => step.applicationStatus === 'reappraisalBoardW_President').judgment)
      // .find(step => step.applicationStatus === 'reappraisalBoardW_Vice').judgment)
    },
    returnToPresidentAllowed () {
      return this.isCurrentUserLeader && !this.reappraisalProposalFound && this.returnToPresident && this.returnComment.length >= 5
    },
    saveMessage () {
      if (this.myJudgment.fullyAgreeWithReappraisal === true) {
        return 'Δηλώσατε οτι συμφωνείτε με την εισήγηση της Ειδικής Επιτροπής Επανεξέτασης. Θέλετε να συνεχίσετε;'
      } else if (this.myJudgment.fullyAgreeWithReappraisal === false) {
        return 'Δηλώσατε οτι διαφωνείτε με την εισήγηση της Ειδικής Επιτροπής Επανεξέτασης. Για να προχωρήσει η αίτηση χρειάζεται να γίνει ανέβασμα νέας εισήγησης με την οποία να συμφωνούν όλα τα μέλη.'
      }
    },
    cannotSave () {
      if (!this.reappraisalProposalFound || [null, false].includes(this.myJudgment.fullyAgreeWithReappraisal) || this.myJudgment.finalize) {
        return true
      } else return false
    },
    ...mapGetters({ currentUser: 'currentUser', userScope: 'userScope', activeRole: 'activeRole', internalUsers: 'internalUsers', loadingInternalUsers: 'loadingInternalUsers' }),
    ...mapState([
      'assignedApplications',
      'workingApplication',
      'reappBoardAttachments',
      'showWorkingApplication',
      'pendingNotifications',
      'loadingAssignedApplications',
      'loadingWorkingApplication',
      'BASE_URL',
      'activeLane',
      'OVERDUE_MESSAGE'
    ])
  },
  watch: {
    reappraisalProposalFound: {
      immediate: true,
      handler (newValue) {
        if (newValue) {
          this.returnToPresident = false
          this.uploadedDocType = 1014
        }
      }
    },
    cannotSave: (oldValue, newValue) => {
      this.cannotSave = newValue
    }
  }
}
</script>

<style lang="scss" scoped>
.commentText {
  width: 700px;
}
.el-checkbox__label {
  background-color: transparent;
}
.el-form-item {
  // color: rgb(30, 0, 128);
  // font-weight: bold;
  /* border-radius: 10px;
  border-style: solid;
  border-color: #7fa3bb green #86b8da yellow;
  border-width: 0px 0px 2px 0px; */
  padding-right: 20px;
}
hr {
  border-color: #7da0b8;
}
.el-alert {
  width: 350px;
  font-style: normal;
  text-align:left;
  display: inline;
}
.text-red {
  font-style:normal;
  color:crimson;
}
.agree-btn {
    background-color: #67c23a;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.disagree-btn {
    background-color: red;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.done-btn {
    background-color: #67c23a;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.pending-btn {
    background-color: orange;
    border-radius: 20px;
    color: #fff;
    display: inline-block;
    font-size: 14px;
    height: 26px;
    line-height: 26px;
    padding: 0 6px;
    text-align: center;
    white-space: nowrap;
    border: 1px solid #fff;
}
.return-comment {
  background-color:red;
  padding: 3px;
}
</style>



// WEBPACK FOOTER //
// src/components/roleSpecific/ReappraisalBoardMemberJudgment.vue